module.exports = __webpack_public_path__ + "img/logo.d9b3e580.svg";